import { render, staticRenderFns } from "./MessageWindow.vue?vue&type=template&id=42f43b44&"
import script from "./MessageWindow.vue?vue&type=script&lang=js&"
export * from "./MessageWindow.vue?vue&type=script&lang=js&"
import style0 from "./MessageWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports